import { useEffect } from "react";
import { Control, useFormContext, useWatch } from "react-hook-form";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM } from "../../../../../../config/constants";
import { MEASUREMENT_TYPES } from "../../../../../../config/enums/MeasurementTypes";
import { cn } from "../../../../../../lib/utils";

const UNIT_FIELD = "unitSizeWeightUnit";

interface PackagingWeightInputProps {
  control: Control<any>;
  name: string;
  weightUnit: MEASUREMENT_TYPES;
  onUnitChange: (value: MEASUREMENT_TYPES) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
}

const PackagingWeightInput = ({
  control,
  name,
  weightUnit,
  onUnitChange,
  disabled = false,
  placeholder = "Enter unit size",
  className,
  id
}: PackagingWeightInputProps) => {
  const { setValue } = useFormContext();
  const watchedUnit = useWatch({ control, name: UNIT_FIELD });

  useEffect(() => {
    setValue(UNIT_FIELD, String(weightUnit));
  }, [weightUnit, setValue]);

  useEffect(() => {
    if (watchedUnit == null || watchedUnit === "") return;
    const numericUnit = Number(watchedUnit);
    if (!Number.isNaN(numericUnit) && numericUnit !== weightUnit) {
      onUnitChange(numericUnit as MEASUREMENT_TYPES);
    }
  }, [watchedUnit, weightUnit, onUnitChange]);

  return (
    <div className={cn("tw-max-w-xs [&_label]:tw-hidden", className)} id={id}>
      <FormUnitInput
        control={control}
        name={name}
        label=""
        placeholder={placeholder}
        disabled={disabled}
        min={0}
        enableLimitedDecimal
        unitName={UNIT_FIELD}
        unitOptions={WEIGHT_UNIT_TYPES_OPTIONs_WITH_GRAM}
      />
    </div>
  );
};

export default PackagingWeightInput;
